module.exports = __webpack_public_path__ + "static/media/personatom.5e4cc5ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/FacilityManage/personatom.jpg
// module id = 159
// module chunks = 0